import { FormMaxWidth } from 'modules/layout/styled';
import { Button, ButtonType } from 'modules/ui';
import { useTranslation } from 'react-i18next';
import { FormButtonContainer } from '../formButtonContainer/FormButtonContainer';

export interface FormButtonsProps {
  onPreviousStep?: () => void;
  onSubmit?: () => void;
  text?: string;
  centered?: boolean;
  rightAligned?: boolean;
  hideSubmitButton?: boolean;
  ariaLabel?: string;
}

export const FormButtons: React.FC<FormButtonsProps> = ({
  onPreviousStep,
  onSubmit,
  text,
  centered,
  rightAligned,
  hideSubmitButton = false,
  ariaLabel
}) => {
  const { t } = useTranslation();

  return (
    <FormButtonContainer
      maxWidth={FormMaxWidth}
      centered={centered}
      rightAligned={rightAligned}>
      {/* Previous step button will be shown only when there
       * is need for it, when the onPreviousStep function is passed
       * as prop. Submit button is always shown. (if hideSubmitButton is false) */}
      {onPreviousStep && (
        <Button
          text={t('form.formButtons.previousStep')}
          type={ButtonType.Secondary}
          onClick={onPreviousStep}
          ariaLabel={ariaLabel}
        />
      )}
      {!hideSubmitButton && (
        <Button
          text={text ?? t('form.formButtons.nextStep')}
          type={ButtonType.Primary}
          submit={!onSubmit}
          onClick={onSubmit ?? undefined}
          ariaLabel={ariaLabel}
        />
      )}
    </FormButtonContainer>
  );
};
